import { useContext } from 'react';
import { AppContext } from "../context/AppContext";
import axios from 'axios';

const PURCHASE_PRODUCT_VC = process.env.REACT_APP_PURCHASE_PRODUCT_VC;

const useApp = () => {
    const [state, setState] = useContext(AppContext);

    function uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    const getPropusk = () => {
        axios.post(PURCHASE_PRODUCT_VC,
            { "product_code": "claimsumfeststart", "language": "ru", "transaction_id": uuidv4(), "expected_prices": [{ "code": "gold", "amount": "0", "item_type": "currency" }] }, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(() => {
                setState(state => ({ ...state, updataData: true }));
                setState(state => ({ ...state, isPropusk: true }));
            });
    }

    const updatePropusk = () => {
        setState(state => ({ ...state, isPropusk: true }));
    }

    return {
        updatePropusk,
        getPropusk,
        isPropusk: state.isPropusk,
        updataData: state.updataData,
    }
};

export default useApp;